import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapActions, mapState } from "vuex";
import { CURRENT_USER_DETAILS } from "@Broker/@Modules/main/store/account/account-getters";
import { LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS } from "@Broker/@Modules/settings/store/settings-actions";
import { SUBMIT_TO_FILOGIX, TOGGLE_FILOGIX_SUBMISSION_PROGRESS, LOAD_FILOGIX_SUBMISSIONS } from "../../../../../store/application-actions";
import { delay } from "@Shared/utils/utils";
import { showToast } from "@Shared/utils/constants";
import Amplitude from "@Shared/utils/amplitude";
import Err from "@Broker/@Routes/error";
import { ORDERED_FILOGIX_SUBMISSIONS } from "../../../../../store/application-getters";
import DealsLoader from "../filogix-deals/deals-loader.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "SubmitCard",
  components: {
    DealsLoader
  },
  props: {
    clientUsername: {
      type: String,
      required: true
    },
    applicationId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      destroyed: false,
      fetchingDetails: false,
      filogixDetails: {},
      loading: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [ORDERED_FILOGIX_SUBMISSIONS])), mapGetters("AccountStore", [CURRENT_USER_DETAILS])), mapState("ApplicationStore", {
    submissionInProgress(state) {
      var _state$filogix$pendin;
      return (_state$filogix$pendin = state.filogix.pendingSubmissions.byApplication[this.applicationId]) == null ? void 0 : _state$filogix$pendin.submitting;
    }
  })), mapState("SettingsStore", {
    savedFilogixDetails(state) {
      return state.filogixDetails;
    }
  })), {}, {
    filogixSubmissions() {
      return this.ORDERED_FILOGIX_SUBMISSIONS(this.applicationId);
    },
    latestDeal() {
      var _this$filogixSubmissi;
      return ((_this$filogixSubmissi = this.filogixSubmissions) == null ? void 0 : _this$filogixSubmissi[0]) || {};
    }
  }),
  watch: {
    latestDeal: {
      immediate: true,
      handler(val) {
        if (!this.submissionInProgress && (val == null ? void 0 : val.status) === "processing") {
          this.toggleSubmissionProgress(true);
          this.watchLatestSubmission();
        }
      }
    },
    savedFilogixDetails(val) {
      this.$set(this, "filogixDetails", val);
    }
  },
  beforeDestroy() {
    this.destroyed = true;
  },
  async mounted() {
    var _this$latestDeal;
    await this.LOAD_FILOGIX_DETAILS();
    if (((_this$latestDeal = this.latestDeal) == null ? void 0 : _this$latestDeal.status) !== "processing") {
      this.toggleSubmissionProgress(false);
    }
    this.loading = false;
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("SettingsStore", [LOAD_FILOGIX_DETAILS, UPDATE_FILOGIX_DETAILS])), mapActions("ApplicationStore", [SUBMIT_TO_FILOGIX, TOGGLE_FILOGIX_SUBMISSION_PROGRESS, LOAD_FILOGIX_SUBMISSIONS])), {}, {
    toggleSubmissionProgress(submitting) {
      this.TOGGLE_FILOGIX_SUBMISSION_PROGRESS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername,
        submitting
      });
    },
    async loadFilogixSubmissions() {
      await this.LOAD_FILOGIX_SUBMISSIONS({
        applicationId: this.applicationId,
        clientUsername: this.clientUsername
      });
    },
    async triggerFilogixSubmission(filogixPassword) {
      this.toggleSubmissionProgress(true);
      try {
        await this.UPDATE_FILOGIX_DETAILS(this.filogixDetails);
        await this.submitToFilogix(filogixPassword);
        this.watchLatestSubmission();
      } catch (e) {
        this.toggleSubmissionProgress(false);
        Err.handle(e);
      }
    },
    async submitToFilogix(filogixPassword) {
      try {
        await this.SUBMIT_TO_FILOGIX({
          applicationId: this.applicationId,
          clientUsername: this.clientUsername,
          filogixPassword
        });
      } catch (e) {
        // we only want to expose error to user if we had an actual response
        // and is not a timeout
        if (e.status != 504 && e.responseJSON) {
          throw e;
        }
      }
    },
    async watchLatestSubmission() {
      do {
        if (this.destroyed) return;
        await delay(5000);
        await this.loadFilogixSubmissions();
      } while (this.latestDeal.status === "processing");
      if (this.latestDeal.status === "failed") {
        showToast("error", "failedToSubmit");
        Amplitude.logEvent("SUBMIT_TO_FILOGIX", {
          clientUsername: this.clientUsername,
          submissionStatus: "failed"
        });
      } else {
        showToast("success", "appSubmittedToFilogix");
      }
      this.toggleSubmissionProgress(false);
    }
  })
});